import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Send } from "lucide-react";
import { Input } from "./ui/input";
import { Textarea } from "./ui/textarea";
import { Label } from "./ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import { api } from "../lib/api";

export default function ContactForm({ services = [], cities = [], defaultCity, defaultService }) {
  const [form, setForm] = useState({ name: "", phone: "", email: "", city: defaultCity || "", service: defaultService || "", message: "" });
  const [loading, setLoading] = useState(false);
  const set = (k) => (v) => setForm((f) => ({ ...f, [k]: v?.target ? v.target.value : v }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.phone) { toast.error("Merci d'indiquer votre nom et votre téléphone."); return; }
    setLoading(true);
    try {
      const payload = { ...form };
      if (!payload.email) delete payload.email;
      await api.post("/contact", payload);
      toast.success("Demande envoyée ! Nous vous rappelons très vite.");
      setForm({ name: "", phone: "", email: "", city: defaultCity || "", service: defaultService || "", message: "" });
    } catch {
      toast.error("Une erreur est survenue. Appelez-nous directement.");
    } finally { setLoading(false); }
  };

  return (
    <form onSubmit={submit} data-testid="contact-form" className="rounded-2xl border border-zinc-200 bg-white p-7 sm:p-9 space-y-5 shadow-lg shadow-zinc-200/50">
      <div className="grid sm:grid-cols-2 gap-5">
        <div className="space-y-2">
          <Label className="text-zinc-700">Nom *</Label>
          <Input data-testid="input-name" value={form.name} onChange={set("name")} placeholder="Votre nom" className="h-12" />
        </div>
        <div className="space-y-2">
          <Label className="text-zinc-700">Téléphone *</Label>
          <Input data-testid="input-phone" value={form.phone} onChange={set("phone")} placeholder="06 12 34 56 78" className="h-12" />
        </div>
      </div>
      <div className="space-y-2">
        <Label className="text-zinc-700">Email</Label>
        <Input data-testid="input-email" type="email" value={form.email} onChange={set("email")} placeholder="vous@email.fr" className="h-12" />
      </div>
      <div className="grid sm:grid-cols-2 gap-5">
        <div className="space-y-2">
          <Label className="text-zinc-700">Ville</Label>
          <Select value={form.city} onValueChange={set("city")}>
            <SelectTrigger data-testid="select-city" className="h-12"><SelectValue placeholder="Choisir" /></SelectTrigger>
            <SelectContent className="max-h-64">{cities.map((c) => <SelectItem key={c.slug} value={c.name}>{c.name}</SelectItem>)}</SelectContent>
          </Select>
        </div>
        <div className="space-y-2">
          <Label className="text-zinc-700">Service</Label>
          <Select value={form.service} onValueChange={set("service")}>
            <SelectTrigger data-testid="select-service" className="h-12"><SelectValue placeholder="Choisir" /></SelectTrigger>
            <SelectContent>{services.map((s) => <SelectItem key={s.slug} value={s.name}>{s.name}</SelectItem>)}</SelectContent>
          </Select>
        </div>
      </div>
      <div className="space-y-2">
        <Label className="text-zinc-700">Votre message</Label>
        <Textarea data-testid="input-message" value={form.message} onChange={set("message")} placeholder="Décrivez votre besoin…" className="min-h-[110px]" />
      </div>
      <button type="submit" disabled={loading} data-testid="submit-contact"
        className="w-full flex items-center justify-center gap-2.5 rounded-full bg-primary py-4 font-semibold text-white shadow-lg shadow-primary/25 hover:scale-[1.01] transition-transform duration-200 disabled:opacity-60">
        {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : <Send className="h-4 w-4" />}
        {loading ? "Envoi…" : "Envoyer ma demande"}
      </button>
      <p className="text-xs text-zinc-500 text-center">Réponse rapide · Devis gratuit et sans engagement</p>
    </form>
  );
}
